import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../utils/axiosSetup.js';
import ProjectReportExport from './export/projectReportExport.jsx';
import { convertTimeToDecimal } from '../../../action/timeCalculation.jsx';


const ProjectReport = () => {
    const [timelogs, setTimeLogs] = useState([]);
    const [channels, setChannels] = useState([]);
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState('');
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedProject, setSelectedProject] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState('');
    
    const fetchdata = async () => {
        try {
            const timelogRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/timelogs?date=false`);
            setTimeLogs(timelogRes.data.data.timelog);

            const channelRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`);
            setChannels(channelRes.data.data);

            const clientRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients`);
            setClients(clientRes.data.data);

            const projectRes = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects`);
            setProjects(projectRes.data.data);
        } catch (error) {
            console.error("Error fetching data!", error);
            setTimeLogs([]); setChannels([]); setClients([]); setProjects([]);
        }
    };

    useEffect(() => {
        fetchdata();
    }, [selectedChannel]);
    
    
    // Filter clients based on selected channel
    const filteredClients = selectedChannel 
        ? clients.filter(client => parseInt(client.channel_id) === parseInt(selectedChannel)) 
        : [];

    // Filter projects based on selected client
    const filteredProjects = selectedClient 
        ? projects.filter(project => parseInt(project.client_id) === parseInt(selectedClient)) 
        : [];

    // Search input handler
    const filteredItems = timelogs.filter((item) => {
        var channel     = parseInt(selectedChannel);
        var client      = parseInt(selectedClient);
        var project     = parseInt(selectedProject);
        var employee    = parseInt(selectedEmployee);
        const matchesChannel    = channel ? parseInt(item.channel_id) === channel : false;
        const matchesClient     = client ? parseInt(item.client_id) === client : true;
        const matchesProject    = project ? parseInt(item.project_id) === project : true;
        const matchesEmployee   = employee ? parseInt(item.user_id) === employee : true;

        return matchesChannel && matchesClient && matchesProject && matchesEmployee;
    });

    //Filter employees from timelog
    const employeesData = filteredItems.map( ({user_id, user_name, total_time_spend, upwork_hours, non_bill_hours }) => ({
        user_id,
        user_name,
        total_time_spend: convertTimeToDecimal(total_time_spend || '00:00'),
        billable_time: convertTimeToDecimal(upwork_hours || '00:00'),
        non_bill_hours: convertTimeToDecimal(non_bill_hours || '00:00'),
    }));

    // UNIQUE employees
    const employees = employeesData.reduce((acc, curr) => {
        const existingUser = acc.find(user => user.user_id === curr.user_id);
        if (existingUser) {
            existingUser.total_time_spend += curr.total_time_spend;
            existingUser.billable_time += curr.billable_time;
            existingUser.non_bill_hours += curr.non_bill_hours;
        } else {
            acc.push({ ...curr });
        }

        return acc;
    }, []);
    

    const billableTime = employees.reduce((total, timelog) => {
                    return total + convertTimeToDecimal(timelog.billable_time.toString() || '00:00');
                }, 0);

    const nonBillableTime = employees.reduce((total, timelog) => {
                    return total + convertTimeToDecimal(timelog.non_bill_hours.toString() || '00:00');
                }, 0);

    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Project Reports</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Project Reports</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selectedChannel}
                            onChange={(event) => {setSelectedChannel(event.target.value); setSelectedClient(''); setSelectedProject('');}}>
                                <option value="">Select Channel</option>
                                {channels.map(row => (
                                    <option key={row.id} value={row.id}>{row.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selectedClient}
                            onChange={(event) => {setSelectedClient(event.target.value); setSelectedProject('');}}>
                                <option value="">Select Client</option>
                                {filteredClients.map(row => (
                                    <option key={row.id} value={row.id}>{row.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selectedProject}
                            onChange={(event) => {setSelectedProject(event.target.value)}}>
                                <option value="">Select Project</option>
                                {filteredProjects.map(row => (
                                    <option key={row.id} value={row.id}>{row.title}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selectedEmployee}
                            onChange={(event) => {setSelectedEmployee(event.target.value)}}>
                                <option value="">Select Employee</option>
                                {employees.map(row => (
                                    <option key={row.user_id} value={row.user_id}>{row.user_name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                    </div>

                    <div className="col-md-2" align="right">
                        <ProjectReportExport data={filteredItems} fileName="ProjectReports" 
                                            billableTime={billableTime} nonBillableTime={nonBillableTime}/>
                    </div>
                </div>
                

                <div className="card">
                    <div className="card-body">
                        <div className="row text-end">
                            <div className="col-md-12 reporteProjects">
                                <h4>Total Billable Hours: {billableTime.toFixed(2)}</h4>
                                <h4>Total Non-Bill Hours: {nonBillableTime.toFixed(2)}</h4>
                                <h4 className="mt-2">Total Hours: {(billableTime + nonBillableTime).toFixed(2)}</h4>
                            </div>
                        </div>

                        <div className="row">
                            {
                                employees.length > 0 && (
                                    employees.map((row) => (
                                        <div className="col-md-3 col-sm-3 col-lg-3 col-xl-3">
                                            <div className="card bg-light">
                                                <div className="card-body border border-secondary rounded">
                                                    <h4 className="mb-2">{row.user_name}</h4>
                                                    <div>Total Hours : {(row.billable_time+row.non_bill_hours).toFixed(2)}</div>
                                                    <div>Total Billable Hours : {row.billable_time.toFixed(2)}</div>
                                                    <div>Total Non-Billable Hours : {row.non_bill_hours.toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )
                            }
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered custom-table adminData">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Channel</th>
                                                <th>Client</th>
                                                <th>Billing <br />Type</th>
                                                <th>Meter</th>
                                                <th>Project</th>
                                                <th>Employee</th>
                                                <th>Department</th>
                                                <th>Total <br />Hours</th>
                                                <th>Billable <br />Hours</th>
                                                <th>Non-<br />Billable <br />Hours</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((timelog) => (
                                                        <tr key={timelog.id}>
                                                            <td>{timelog.channel || ""}</td>
                                                            <td>{timelog.client || ""}</td>
                                                            <td>{timelog.billing_type || ""}</td>
                                                            <td>{timelog.meter || "N/A"}</td>
                                                            <td>{timelog.project || ""}</td>
                                                            <td>{timelog.user_name || ""}</td>
                                                            <td>{timelog.department || ""}</td>
                                                            <td>{timelog.time_spend || "00.00"}</td>
                                                            <td>{timelog.billable_time || "00.00"}</td>
                                                            <td>{timelog.nonbillable_time || "00.00"}</td>
                                                            <td width={250} className="descWrap">
                                                                {timelog.billable_description !== '' &&
                                                                    <><b>Billable Description:</b> <br />
                                                                        {timelog.billable_description || 'N/A'}</>
                                                                } <br />
                                                                {timelog.nonbillable_description !== '' &&
                                                                    <><b>Non-Billable Description:</b> <br />
                                                                        {timelog.nonbillable_description || 'N/A'}</>
                                                                }
                                                            </td>
                                                            <td>{timelog.time_log_date.split(' ')[0] || ""}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="12">No record found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProjectReport